var exports = {
  "k": "x7f9a0e16--d2ade6--container",
};

module.exports = exports;
